let state = {};

state.phanHoi = {
    refreshFnCountNew: 0,
};
state.mapBox = {
    refreshMapBox: 0,
};

export default state;